import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";

const PAGE_TITLES = {
  "/": "1031Condo.com | 1031 Exchange Replacement Condo Units | NYC & Miami",
  "/properties": "Available Condo Units | 1031 Exchange Properties in NYC & Miami",
  "/nyc": "NYC Condo Units | 1031 Exchange Replacement Properties in New York City",
  "/miami": "Miami Condo Units | 1031 Exchange Replacement Properties in Miami",
  "/guide": "1031 Exchange Guide | Rules, Timelines & Requirements",
  "/process": "1031 Exchange Process | Step-by-Step Property Identification",
  "/calculator": "1031 Exchange Tax Deferral Calculator | Estimate Your Savings",
  "/about": "About Krieger Real Estate | 1031 Exchange Property Specialists",
  "/contact": "Contact Us | 1031 Exchange Property Sourcing",
  "/resources": "1031 Exchange Resources | Educational Materials & Tools",
  "/management": "Condo Unit Management | NYC & Miami Property Management Services",
  "/portal": "Client Portal | 1031Condo.com",
  "/compare": "Compare Buildings | Side-by-Side Property Analysis",
  "/replacement-finder": "1031 Replacement Property Finder | Search & Identify Properties",
  "/privacy": "Privacy Policy | 1031Condo.com",
  "/terms": "Terms of Service | 1031Condo.com",
  "/disclaimer": "Disclaimer | 1031Condo.com",
};

// Pages
import HomePage from "@/pages/HomePage";
import GuidePage from "@/pages/GuidePage";
import PropertiesPage from "@/pages/PropertiesPage";
import PropertyDetailPage from "@/pages/PropertyDetailPage";
import NYCPage from "@/pages/NYCPage";
import MiamiPage from "@/pages/MiamiPage";
import ProcessPage from "@/pages/ProcessPage";
import AboutPage from "@/pages/AboutPage";
import ResourcesPage from "@/pages/ResourcesPage";
import ContactPage from "@/pages/ContactPage";
import CalculatorPage from "@/pages/CalculatorPage";
import ClientPortal from "@/pages/ClientPortal";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProperties from "@/pages/AdminProperties";
import AdminReports from "@/pages/AdminReports";
import AuthCallback from "@/pages/AuthCallback";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import CondoManagementPage from "@/pages/CondoManagementPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminScraper from "@/pages/AdminScraper";
import AdminAudits from "@/pages/AdminAudits";
import ReplacementFinder from "@/pages/ReplacementFinder";
import SharedSearch from "@/pages/SharedSearch";
import BuildingComparison from "@/pages/BuildingComparison";

// Layout
import Layout from "@/components/Layout";

function AppRouter() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    document.title = PAGE_TITLES[path] || "1031Condo.com | 1031 Exchange Replacement Properties";

    // Notify Google Analytics of SPA route changes (gtag is loaded in index.html)
    if (typeof window.gtag === "function") {
      window.gtag("config", "G-FET02280M0", {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="guide" element={<GuidePage />} />
        <Route path="properties" element={<PropertiesPage />} />
        <Route path="properties/:id" element={<PropertyDetailPage />} />
        <Route path="nyc" element={<NYCPage />} />
        <Route path="miami" element={<MiamiPage />} />
        <Route path="process" element={<ProcessPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="resources" element={<ResourcesPage />} />
        <Route path="calculator" element={<CalculatorPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="disclaimer" element={<DisclaimerPage />} />
        <Route path="management" element={<CondoManagementPage />} />
        <Route path="replacement-finder" element={<ReplacementFinder />} />
        <Route path="replacement-finder/shared/:shareId" element={<SharedSearch />} />
        <Route path="compare" element={<BuildingComparison />} />
      </Route>
      <Route path="/portal" element={<ClientPortal />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/properties" element={<AdminProperties />} />
      <Route path="/admin/reports" element={<AdminReports />} />
      <Route path="/admin/reports/:reportId" element={<AdminReports />} />
      <Route path="/admin/scraper" element={<AdminScraper />} />
      <Route path="/admin/audits" element={<AdminAudits />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
